/**
 * @description: 获取新闻详情
 * @return {Object}
 */
export async function getListDetail(data: any = {}) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/information/news/detail`, data)
  return result
}

/**
 * @description: 获取新闻列表
 * @return {Object}
 */
export async function getNewsList(data: any = {}) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/information/news/list`, data)
  return result
}

/**
 * @description: 获取标签数据
 * @return {Object}
 */
export async function getTagList(data: any = {}) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/information/news/keywordList`, data)
  return result
}

/**
 * @description: 获取success list
 * @return {Object}
 */
export async function getSuccessListApi(data: any) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/successCase/pageList`, data)
  return result
}

/**
 * @description: 获取success detail
 * @return {Object}
 */
export async function getSuccessDetailApi(data: any) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/successCase/detail`, data)
  return result
}

/**
 * @description: success 点赞
 * @return {Object}
 */
export async function successLikeApi(data: any) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/successCase/like`, data)
  return result
}

/**
 * @description: success 点赞
 * @return {Object}
 */
export async function successDisLikeApi(data: any) {
  const { post } = useUseRequest()
  const result: any = await post(`/era/fr/successCase/cancelLike`, data)
  return result
}

/**
 * @description: 获取枚举数据
 * @return {Object}
 */
export function getEnumApi(data: any): any {
  const { post } = useUseRequest()
  const result = post(`/era/enum/get`, data)
  return result
}
